import { render, staticRenderFns } from "./MessageText.vue?vue&type=template&id=3cd4004c&scoped=true"
import script from "./MessageText.vue?vue&type=script&lang=js"
export * from "./MessageText.vue?vue&type=script&lang=js"
import style0 from "./MessageText.vue?vue&type=style&index=0&id=3cd4004c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd4004c",
  null
  
)

export default component.exports